export default "__VITE_ASSET__ZM5WN7lK__"